import { z } from 'zod';

/////////////////////////////////////////
// PERMITS EXTENSIONS SCHEMA
/////////////////////////////////////////

export const PermitsExtensionsSchema = z.object({
  id: z.bigint(),
  permit_id: z.number().int().nullable(),
  value: z.string().nullable(),
  permits_extension_def_id: z.number().int().nullable(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  permits_form_field_id: z.number().int().nullable(),
  conditionally_visible: z.boolean().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type PermitsExtensions = z.infer<typeof PermitsExtensionsSchema>

export default PermitsExtensionsSchema;
